export interface MemberPromotionDrawerDetailsRowProps {
  className?: string;
  children: React.ReactNode;
  label: string;
}

export const MemberPromotionDrawerDetailsRow = ({
  className = '',
  children,
  label
}: MemberPromotionDrawerDetailsRowProps) => {
  return (
    <div className="flex items-center justify-between gap-4 pb-4">
      <div
        className="text-soClean-180 text-sm"
        data-testid={`promotion-drawer-label-${label}`}
      >
        {label}
      </div>
      <div
        className={`text-soClean-120 text-sm ${className || ''}`}
        data-testid={`promotion-drawer-${label}`}
      >
        {children}
      </div>
    </div>
  );
};
